import { useTitleGenerationStreaming } from '@confluence/editor-features/entry-points/useTitleGenerationStreaming';

export const LivePagesTitleAIGenerationOnPaste = ({
	contentId,
	cloudId,
	locale,
	documentContext,
	skip,
	onTitleChange,
}: {
	contentId: string;
	cloudId: string;
	documentContext: string;
	locale: string;
	skip: boolean;
	onTitleChange: (newTitle: string) => void;
}) => {
	useTitleGenerationStreaming({
		contentId,
		cloudId,
		documentContext,
		locale,
		skip,
		onTitleChange,
	});

	return null;
};
